import React from "react";
import "./Spinner.css";

const spinner = () => <div id="loading" />;

export default spinner;
